import useApiClient from './useApiClient';
import { useGetMobileAppsGroupedStatsQuery, useGetMobileAppsStatsQuery } from '../../store/api-slices';

export const useMobileAppsGroupedStatsApi = (params, options) => {
  const { MobileAppManager } = useApiClient();

  return useGetMobileAppsGroupedStatsQuery({ apiManager: MobileAppManager, ...(params && params) }, options);
};

export const useMobileAppsStatsApi = (params, options) => {
  const { MobileAppManager } = useApiClient();

  return useGetMobileAppsStatsQuery({ apiManager: MobileAppManager, ...(params && params) }, options);
};
